import Component from '../abstracts/Component';

export default class HeaderComponent extends Component {

  get SELECTORS() {
    return {
      main: '.main-header',
      reverse: '.main-header.reverse',
      header: '.main-header',
      mainWrapper: '[role=main]',
      heroWidget: '.c-hero',
      body: 'body',
      scrollIndicator: '.c-exploration-indication'
    };
  }

  get CLASSES() {
    return {
      hidden: 'is-hidden',
      expanded: 'expanded',
      collapsed: 'collapsed',
      transition: 'transition',
      top: 'is-top'
    };
  }

  constructor() {
    super();
    this.timeout = null;
    this.header = document.querySelector(this.SELECTORS.main);
    this.scrollIndicator = document.querySelector(this.SELECTORS.scrollIndicator);
  }

  expandHeader() {
    const ctx = this;
    let top = 0;
    let header = document.querySelector(this.SELECTORS.header);
    let headerH = header.clientHeight;
    let deactivateAtY;

    $(window).scroll(function () {
      let scroll = $(window).scrollTop();

      if (document.querySelector(ctx.SELECTORS.heroWidget) !== null) {
        let hero = document.querySelector(ctx.SELECTORS.heroWidget);
        deactivateAtY = hero.clientHeight / 2;
      } else {
        deactivateAtY = 500;
      }


      if (scroll > top) {
        if (scroll > deactivateAtY) {
          ctx.$emit(ctx.$customEvents.HEADER_EVENTS.expanded);
        }
      }

      if (top > scroll) {
        if (deactivateAtY > scroll) {
          ctx.$emit(ctx.$customEvents.HEADER_EVENTS.collapsed);
        }
      }

      top = scroll;

    });

  }

  pageScrolled() {

    let headerHeight = this.header.offsetHeight;

    if(!(this.header.classList.contains('collapsed')) && document.querySelector('.search-wrapper').classList.contains('is-visible') && !document.body.classList.contains('t-search')){
      headerHeight = this.header.offsetHeight - document.querySelector('.search-wrapper').offsetHeight;
    }

    let offsetT = (this.header.offsetTop + headerHeight) / 2;

    if (document.body.scrollTop > offsetT || document.documentElement.scrollTop > offsetT) {
      this.header.classList.add('collapsed');
      if (this.scrollIndicator) this.scrollIndicator.classList.add('hide');
    } else {
      this.header.classList.remove('collapsed');
      if (this.scrollIndicator) this.scrollIndicator.classList.remove('hide');
    }
  }

  collapseHeader() {
    const ctx = this;
    let top = 0;
    let header = document.querySelector(this.SELECTORS.header);
    let headerH = header.clientHeight;

    $(window).scroll(function () {
      let scroll = $(window).scrollTop();
      let deactivateAtY = 500;

      if (scroll > top && scroll > headerH) {
        ctx.$emit(ctx.$customEvents.HEADER_EVENTS.collapsed);
      }

      if (top > scroll && deactivateAtY > scroll) {
        ctx.$emit(ctx.$customEvents.HEADER_EVENTS.expanded);
      }

      top = scroll;

    });

  }

  bindEvents() {

    this.pageScrolled();

    this.$on('scroll', () => {
      this.pageScrolled();
    });

    this.$on(this.$customEvents.BURGER_EVENTS.click, ({
      payload
    }) => {
      if (payload.menuIn) {
        $(this.SELECTORS.main).addClass(this.CLASSES.top);
      } else {
        $(this.SELECTORS.main).removeClass(this.CLASSES.top);
      }
    })

    this.$on('mouseenter.header', ({
      event
    }) => {
      clearTimeout(this.timeout);
      event.currentTarget.classList.add('animate');
    }, 'body', `${this.SELECTORS.main}:not(.collapsed)`);

    this.$on('mouseleave.header', ({
      event
    }) => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        event.currentTarget.classList.remove('animate');
      }, 500);
    }, 'body', `${this.SELECTORS.main}:not(.collapsed)`);

    let ctx = this;
    this.menuCheck();

    window.addEventListener('resize', () => {
      this.menuCheck();
    });
  }

  menuCheck() {
    if (this.$matchMedia(null, 'lg')) {
      let actions = $('.header-actions');
      let nav = $('nav.navigation .list-default');
      // if the search overlay the menu
      if (actions.offset().left < nav.offset().left+nav.outerWidth(true)) {
        $('.header-actions').addClass('menu_overlayed');
      } else {
        $('.header-actions').removeClass('menu_overlayed');
      }
    }
  }

  render() {
    let header = document.querySelector(this.SELECTORS.header);
    if (header === null) return;

    if(!header.classList.contains('editMode')){
      this.bindEvents();
    }
  }
}
